import React from 'react'
import styles from './BookingsTable.module.sass'
import { Text } from '@shared/ui/Typography/Text'
import { Booking, bookingStatusConfig } from '@pages/OwnerPersonalPage/ui/pages/OwnerBookingPage/OwnerBookingPage'

interface BookingsTableProps {
  bookings: Booking[]
  className?: string
}

const BookingsTable: React.FC<BookingsTableProps> = ({ bookings, className }) => {
  if (bookings.length === 0) {
    return (
      <Text sizes='M' className={`${styles['empty-state']} ${className || ''}`}>
        В этом месяце не было бронирований
      </Text>
    )
  }

  return (
    <div className={`${styles['table-container']} ${className || ''}`} role='grid' aria-label='Bookings table'>
      <div className={styles['header-row']} role='row'>
        <Text sizes='M' className={styles['header-cell']} role='columnheader'>
          Гость
        </Text>

        <Text sizes='M' className={styles['header-cell']} role='columnheader'>
          Места и пожелания
        </Text>

        <Text sizes='M' className={styles['header-cell']} role='columnheader'>
          Дата
        </Text>

        <Text sizes='M' className={styles['header-cell']} role='columnheader'>
          Статус
        </Text>
      </div>

      {bookings.map((booking) => (
        <div key={booking.id} className={styles['table-row']} role='row'>
          <div className={styles['guest-cell']} role='cell'>
            <Text sizes='S' className={styles['guest-name']}>
              {booking.guestName}
            </Text>

            <Text sizes='S' className={styles['guest-phone']}>
              {booking.phone}
            </Text>
          </div>

          <div className={styles['seats-cell']} role='cell'>
            <Text sizes='S' className={styles.seats}>
              {booking.seats}
            </Text>

            {booking.specialRequests && (
              <Text sizes='S' className={styles['special-requests']}>
                {booking.specialRequests}
              </Text>
            )}
          </div>

          <div className={styles['date-cell']} role='cell'>
            <Text sizes='S'>{booking.date},</Text>

            <Text sizes='S'>{booking.time}</Text>
          </div>

          <Text className={styles['status-cell']} role='cell' sizes='S' data-status-type={booking.status}>
            {bookingStatusConfig[booking.status].tableLabel}
          </Text>
        </div>
      ))}
    </div>
  )
}

export default BookingsTable
